import React from 'react';
import ContentPage from '../ContentPage/ContentPage';

const AboutPage: React.FC = () => <ContentPage slug="uber-mich" title="Über mich" />;

export default AboutPage;
